module.exports = __webpack_public_path__ + "static/img/printer.b9647e3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/printer.svg
// module id = 541
// module chunks = 1